import { RemoveLineTypes } from '../../types/panier/panier.def';
import {
  CommandeLinePanier,
  ProductQuantityUpdate
} from '../../types/commandeLine/commandeLine.def';
import { BaseAction, ExtendAction } from '../types';

export const UPDATE_PANIER = 'UPDATE_PANIER';
export const UPDATE_PRODUCT_QUANTITY = 'UPDATE_PRODUCT_QUANTITY';

export const UPDATE_NGO_CONTRIBUTION = 'UPDATE_NGO_CONTRIBUTION';
export const UPDATE_FRAIS_PORT = 'UPDATE_FRAIS_PORT';
export const CLEAR_CART = 'CLEAR_CART';
export const REMOVE_LINE = 'REMOVE_LINE';

export type ClearCartAction = BaseAction<typeof CLEAR_CART>;

export type UpdateNgoContributionAction = ExtendAction<
  boolean,
  typeof UPDATE_NGO_CONTRIBUTION
>;

export const updateNgoContribution = (
  doesClientContributeToNgo: boolean
): UpdateNgoContributionAction => ({
  type: UPDATE_NGO_CONTRIBUTION,
  payload: doesClientContributeToNgo
});

export const clearCart: ClearCartAction = { type: CLEAR_CART };

type RemoveLineAction = ExtendAction<RemoveLineTypes, typeof REMOVE_LINE>;

export const removeLine = (payload: RemoveLineTypes): RemoveLineAction => ({
  type: REMOVE_LINE,
  payload
});

type UpdatePanierAction = ExtendAction<
  CommandeLinePanier,
  typeof UPDATE_PANIER
>;

export const updatePanier = (
  payload: CommandeLinePanier
): UpdatePanierAction => ({
  type: UPDATE_PANIER,
  payload
});

type UpdateProductQuantityAction = ExtendAction<
  ProductQuantityUpdate,
  typeof UPDATE_PRODUCT_QUANTITY
>;

export const updateProductQuantity = (
  payload: ProductQuantityUpdate
): UpdateProductQuantityAction => ({
  type: UPDATE_PRODUCT_QUANTITY,
  payload
});

export type UpdateFraisPortAction = ExtendAction<
  boolean,
  typeof UPDATE_FRAIS_PORT
>;

export const updateFraisPort = (
  isPortApplicable: boolean
): UpdateFraisPortAction => ({
  type: UPDATE_FRAIS_PORT,
  payload: isPortApplicable
});

export type PanierActions =
  | UpdatePanierAction
  | UpdateProductQuantityAction
  | UpdateFraisPortAction
  | RemoveLineAction
  | UpdateNgoContributionAction
  | ClearCartAction;
